import activitiesService from './activitiesService'

export default activitiesService



// WEBPACK FOOTER //
// ../src/services/activitiesService/index.js